// import React, { useEffect, useState } from "react";
// import "./SavedAddress.css";
// import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTrash } from "@fortawesome/free-solid-svg-icons";
// import { useNavigate } from "react-router-dom";
// import Successfull_Modal from "../Common_modal/Successfull_Modal/Successfull_Modal";
// import Green_Btn from "../Common-Component/common_btn/green_btn/Green_Btn";
// import { getAddress } from "../../utils/apis/orderProcess/orderProcess";

// const SavedAddress = () => {
//   const navigate = useNavigate();

//   const [showSuccessModal, setShowSucsessModal] = useState(false);
//   const [selectedAddressId, setSelectedAddressId] = useState(null);

//   const [address, setAddress] = useState([]);
//   console.log(address, "address address");

//   const addressGet = async () => {
//     const res = await getAddress();
//     console.log(res, "res");
//     if (res?.success) {
//       await setAddress(res?.data);
//     }
//   };

//   useEffect(() => {
//     addressGet();
//   }, []);

//   const renderTooltip = (props) => (
//     <Tooltip id="button-tooltip" {...props}>
//       DELETE ADDRESS
//     </Tooltip>
//   );

//   return (
//     <section className="SavedAddress">
//       <div className="container">
//         <p
//           className="back_text"
//           onClick={() => {
//             navigate("/product-cart");
//           }}
//         >
//           Back
//         </p>

//         <div className="add_new_address_div">
//           <div className="address_title_div">
//             <div className="heading_div">
//               <p>Saved Address</p>
//             </div>
//             <div className="btn_holder">
//               <Button
//                 className="add_new_btn"
//                 type="button"
//                 onClick={() => {
//                   navigate("/add-new-address");
//                 }}
//               >
//                 Add New
//               </Button>
//             </div>
//           </div>
//         </div>

//         <div className="saved_address_main_div">
//           <div className="addres_card_holder">
//             <div className="row">
//               {address?.map((value, index) => {
//                 return (
//                   <div
//                     className="col-lg-4 col-md-6 col-sm-12 col-12"
//                     key={index}
//                   >
//                     <div className="address_card">
//                       <div className="top_address_heading">
//                         <div className="heading">
//                           <p>{value?.address_type}</p>
//                         </div>

//                         <div className="form-holder">
//                           {/* <Form.Check type="radio" id="1" /> */}
//                           <Form.Check
//                             type="radio"
//                             name="selectedAddress"
//                             checked={selectedAddressId === value.id}
//                             onChange={() => setSelectedAddressId(value.id)}
//                           />
//                         </div>
//                       </div>

//                       <div className="user_address">
//                         <div>
//                           <p className="user_name">{value?.name}</p>
//                         </div>

//                         <div>
//                           <p className="contact_no">{value?.mobile_number}</p>
//                         </div>

//                         <div className="footer_div">
//                           <div className="address_div">
//                             <p>
//                               {`${value?.flat_home_bldg},${value?.col_land_strt},${value?.society_name},${value?.area_name}`}
//                             </p>
//                           </div>
//                         </div>
//                       </div>

//                       <div className="edit_btn_div">
//                         {/* <p
//                           onClick={() => {
//                             navigate("/add-new-address");
//                           }}
//                         >
//                           Edit
//                         </p> */}

//                         <p
//                           onClick={() => {
//                             navigate(`/add-new-address?id=${value?.id}`);
//                           }}
//                         >
//                           Edit
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>

//           <div
//             className="delete_icon_holder"
//             // onClick={() => {
//             //   setShowSucsessModal(true);
//             // }}

//             onClick={() => {
//               if (!selectedAddressId) {
//                 alert("Please select an address to delete.");
//                 return;
//               }
//               setShowSucsessModal(true);
//             }}
//           >
//             <OverlayTrigger
//               placement="right"
//               delay={{ show: 250, hide: 400 }}
//               overlay={renderTooltip}
//             >
//               <FontAwesomeIcon icon={faTrash} className="delete_icon" />
//             </OverlayTrigger>
//           </div>
//         </div>

//         <div className="text-center address_btn_holder">
//           <div className="">
//             {/* <Button className="submit-btn" type="button" >
//                             Proceed with Saved Address
//                         </Button> */}
//             <Green_Btn
//               btn_name="Proceed with Saved Address"
//               onClick={() => {
//                 navigate("/checkout");
//               }}
//             />
//           </div>
//         </div>
//       </div>

//       <Successfull_Modal
//         show={showSuccessModal}
//         onHide={() => {
//           setShowSucsessModal(false);
//         }}
//         message="Address Deleted successfully!"
//       />
//     </section>
//   );
// };

// export default SavedAddress;

import React, { useEffect, useState } from "react";
import "./SavedAddress.css";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Successfull_Modal from "../Common_modal/Successfull_Modal/Successfull_Modal";
import Green_Btn from "../Common-Component/common_btn/green_btn/Green_Btn";
import {
  getAddress,
  DeleteAddress,
} from "../../utils/apis/orderProcess/orderProcess";

const SavedAddress = () => {
  const navigate = useNavigate();

  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [address, setAddress] = useState([]);

  const addressGet = async () => {
    const res = await getAddress();
    if (res?.success) {
      setAddress(res?.data);
    }
  };

  useEffect(() => {
    addressGet();
  }, []);

  const handleDelete = async () => {
    await DeleteAddress(selectedAddressId);
    await addressGet();
    setShowSucsessModal(true);
    setSelectedAddressId(null);
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      DELETE ADDRESS
    </Tooltip>
  );

  return (
    <section className="SavedAddress">
      <div className="container">
        <p className="back_text" onClick={() => navigate("/product-cart")}>
          Back
        </p>

        <div className="add_new_address_div">
          <div className="address_title_div">
            <div className="heading_div">
              <p>Saved Address</p>
            </div>
            <div className="btn_holder">
              <Button
                className="add_new_btn"
                onClick={() => navigate("/add-new-address")}
              >
                Add New
              </Button>
            </div>
          </div>
        </div>

        <div className="saved_address_main_div">
          <div className="addres_card_holder">
            <div className="row">
              {address?.map((value, index) => (
                <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={index}>
                  <div className="address_card">
                    <div className="top_address_heading">
                      <p><b>{value?.address_type}</b></p>

                      <Form.Check
                        type="radio"
                        name="selectedAddress"
                        checked={selectedAddressId === value.id}
                        onChange={() => setSelectedAddressId(value.id)}
                      />
                    </div>

                    <div className="user_address">
                      <p className="user_name">{value?.name}</p>
                      <p className="contact_no">{value?.mobile_number}</p>
                      {/* <p className="address_div">
                        {`${value?.flat_home_bldg}, ${value?.col_land_strt}, ${value?.society_name}, ${value?.area_name}`}
                      </p> */}
                      <p className="address_div">
                        {(() => {
                          const parts = [];

                          // Common fields
                          if (value?.flat_home_bldg)
                            parts.push(value.flat_home_bldg);

                          // Address type specific logic
                          if (value?.address_type === "Apartment") {
                            if (value?.apt_number)
                              parts.push(`Apt ${value.apt_number}`);
                            if (value?.floor)
                              parts.push(`Floor ${value.floor}`);
                            if (value?.society_name)
                              parts.push(value.society_name);
                          } else if (value?.address_type === "House") {
                            if (value?.floor)
                              parts.push(`Floor ${value.floor}`);
                            if (value?.society_name)
                              parts.push(value.society_name);
                          } else if (value?.address_type === "Office") {
                            if (value?.company) parts.push(value.company);
                            if (value?.floor)
                              parts.push(`Floor ${value.floor}`);
                          }

                          // Common area & street
                          if (value?.col_land_strt)
                            parts.push(value.col_land_strt);
                          if (value?.area_name) parts.push(value.area_name);

                          // Additional direction (optional)
                          if (value?.additional_direction)
                            parts.push(value.additional_direction);

                          return parts.length > 0
                            ? parts.join(", ")
                            : "No address details";
                        })()}
                      </p>
                    </div>

                    <div className="edit_btn_div">
                      <p
                        onClick={() =>
                          navigate(`/add-new-address?id=${value.id}`)
                        }
                      >
                        Edit
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* DELETE ICON → Direct Delete */}
          <div
            className="delete_icon_holder"
            onClick={() => {
              if (!selectedAddressId) {
                alert("Please select an address to delete.");
                return;
              }
              handleDelete(); //  Direct delete
            }}
          >
            <OverlayTrigger placement="right" overlay={renderTooltip}>
              <FontAwesomeIcon icon={faTrash} className="delete_icon" />
            </OverlayTrigger>
          </div>
        </div>

        <div className="text-center address_btn_holder">
          {/* <Green_Btn
            btn_name="Proceed with Saved Address"
            onClick={() => navigate("/checkout")}
          /> */}

          <Green_Btn
            btn_name="Proceed with Saved Address"
            onClick={() => {
              if (!selectedAddressId) {
                alert("Please select at least one address.");
                return;
              }

              // Find selected address details
              const selectedData = address.find(
                (item) => item.id === selectedAddressId
              );

              // Store in localStorage so Checkout page can read it
              localStorage.setItem(
                "selectedAddress",
                JSON.stringify(selectedData)
              );

              navigate("/checkout");
            }}
          />
        </div>
      </div>

      {/* SUCCESS MODAL */}
      <Successfull_Modal
        show={showSuccessModal}
        onHide={() => setShowSucsessModal(false)}
        message="Address Deleted successfully!"
      />
    </section>
  );
};

export default SavedAddress;
